import React from 'react'
import Layout from 'components/LayoutForPortal'
const Index = () => {
    return (
        <Layout>
            reports component
        </Layout>
    )
}

export default Index
